// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 見出し */
.segtiles__legend {
  font-size: 12px;
  color: #525252;
  margin-bottom: 6px;
}

/* 横一列（幅が足りなければ自然に折り返し） */
.segtiles__row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;         /* ← 狭いときだけ折り返し */
  gap: 8px;
}

/* ボタン風ラジオ */
.segtiles__btn {
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #c6c6c6;
  background: #ffffff;
  padding: 8px 14px;
  min-width: 100px;        /* ここで最低幅を調整 */
  line-height: 1.2;
  font: inherit;
  cursor: pointer;
  white-space: nowrap;

  display: inline-flex;    /* 横並び崩し防止 */
  align-items: center;
  justify-content: center;

  transition: background .15s ease, border-color .15s ease, box-shadow .15s ease;
}

.segtiles__btn:hover {
  background: #f4f4f4;
}

.segtiles__btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.3);
  border-color: #0f62fe;
}

.segtiles__btn.is-active {
  background: #e6f0ff;
  border-color: #0f62fe;
  color: #0f62fe;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/SegmentedTiles.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,UAAU,iBAAiB;EAC1C,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB,SAAS,cAAc;EACvC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;;EAEnB,oBAAoB,KAAK,YAAY;EACrC,mBAAmB;EACnB,uBAAuB;;EAEvB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* 見出し */\n.segtiles__legend {\n  font-size: 12px;\n  color: #525252;\n  margin-bottom: 6px;\n}\n\n/* 横一列（幅が足りなければ自然に折り返し） */\n.segtiles__row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;         /* ← 狭いときだけ折り返し */\n  gap: 8px;\n}\n\n/* ボタン風ラジオ */\n.segtiles__btn {\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1px solid #c6c6c6;\n  background: #ffffff;\n  padding: 8px 14px;\n  min-width: 100px;        /* ここで最低幅を調整 */\n  line-height: 1.2;\n  font: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n\n  display: inline-flex;    /* 横並び崩し防止 */\n  align-items: center;\n  justify-content: center;\n\n  transition: background .15s ease, border-color .15s ease, box-shadow .15s ease;\n}\n\n.segtiles__btn:hover {\n  background: #f4f4f4;\n}\n\n.segtiles__btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(15, 98, 254, 0.3);\n  border-color: #0f62fe;\n}\n\n.segtiles__btn.is-active {\n  background: #e6f0ff;\n  border-color: #0f62fe;\n  color: #0f62fe;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
